// src/components/PrivateRoute.js
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, role } = useSelector((state) => state.auth);

  // Every routed page already logs its own named "Page viewed" event via
  // usePageLogger (see each page component), so logging the raw path here
  // too just produced a second, less-readable duplicate for every navigation.

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // Check if the user's role is allowed to access this route
  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/dashboard" />; // Redirect if unauthorized
  }

  return children;
};

export default PrivateRoute;
